"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDuplicateModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const collection_duplicate_modal_ctrl_1 = require("./collection.duplicate.modal.ctrl");
const collection_duplicate_modal_style_1 = require("./collection.duplicate.modal.style");
(0, theme_1.addStyles)(collection_duplicate_modal_style_1.Style);
class CollectionDuplicateModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.ctrl = new collection_duplicate_modal_ctrl_1.CollectionDuplicateModalCtrl(collections);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: collection_duplicate_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_duplicate_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_DUPLICATE_CONFIRM, { count: this.ctrl.collections.length }))
            ])
        ]);
    }
    submit() {
        return this.ctrl.duplicateCollections(null);
    }
}
exports.CollectionDuplicateModal = CollectionDuplicateModal;
//# sourceMappingURL=collection.duplicate.modal.js.map